
import React from 'react';



const About = () => {
    return (
        /* This is hard coded about section */
        <div className="container m-5 pb-5" >
            <h2 className="mb-3">About Me</h2>
            <div className="row g-5">
                <div className="col-md-5">
                    <img className="img-fluid pb-5" src="https://i.ibb.co/wS0xsVZ/shanto.jpg" alt="" />
                </div>
                <div className="col-md-7" >ABOUT ME
                    <h2 >
                        <span>I'm Saiful Islam Shanto </span>

                    </h2>
                    <p>Hi, My name is Saiful Islam Shanto. I am dedicated, detailed and capable Web
                        Developer with one years of experience, able to find out solutions of
                        complex problems and loves to take task as a challenge.</p>

                    <div className="row">
                        <div className="col-md-6">
                            <p>Website: sshanto.com</p>
                            <p>Mail: sshanto.cse@gmail.com</p>
                        </div>
                        <div className="col-md-6">
                            <p>Degree: Engineering</p>
                            <p>Linkedin: /saiful-shant0</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
};

export default About;